
import {Mui} from "@osu/react-ui"

function Heading({ text, variant }) {
    return <Mui.Typography variant={variant}>{text}</Mui.Typography>
}

export default Heading